import React from 'react';
import { Card } from './ui/Card';
import { Button } from './ui/Button';
import { Compass, Users } from 'lucide-react';
import { motion } from 'framer-motion';
import { RadiantStar } from './ui/RadiantStar';
export function OfferingsSection() {
  return <section id="offerings" className="relative py-24 bg-gradient-to-b from-earth-900 to-night-900" data-id="element-145" data-mp="21weizty16wlp">
      <div className="absolute inset-0 bg-grain opacity-15 pointer-events-none mix-blend-overlay" data-id="element-146" data-mp="199tfxw870w2b"></div>

      {/* Decorative Stars */}
      <div className="absolute top-20 left-10 opacity-40 pointer-events-none hidden lg:block" data-id="element-147" data-mp="14bi81r1gkvmq">
        <RadiantStar size={32} delay={0.2} data-id="element-148" data-mp="1izv38lsq2ag6" />
      </div>
      <div className="absolute bottom-20 right-10 opacity-40 pointer-events-none hidden lg:block" data-id="element-149" data-mp="1j1g04i2ie5h7">
        <RadiantStar size={40} delay={0.4} data-id="element-150" data-mp="1e720u4kq7e79" />
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 relative z-10" data-id="element-151" data-mp="qi0z106ef1ay">
        <motion.div className="text-center mb-16" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-152" data-mp="lkr1ex8uvjc1">
          <h2 className="font-serif text-4xl md:text-5xl text-cream-50 mb-4" data-id="element-153" data-mp="8cb136q1ly3o">
            Your Journey Continues
          </h2>
          <p className="text-gold-400 text-lg font-medium tracking-wide uppercase" data-id="element-154" data-mp="3cpr2i6jqlzba">
            Choose your path
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto" data-id="element-155" data-mp="3gs472rmqzr6h">
          {/* 1-on-1 Coaching */}
          <Card hover className="flex flex-col items-center text-center border-t-4 border-t-gold-400" data-id="element-156" data-mp="3lpny6s4jnyfu">
            <div className="w-16 h-16 rounded-full bg-gold-400/10 flex items-center justify-center mb-6 text-gold-400" data-id="element-157" data-mp="3qn5y5t0l33bp">
              <Compass size={32} strokeWidth={1.5} data-id="element-158" data-mp="15z1g7c9o3ck1" />
            </div>
            <h3 className="font-serif text-2xl text-cream-50 mb-2" data-id="element-159" data-mp="1614cuf5bs3xq">
              1-on-1 Coaching
            </h3>
            <p className="text-gold-400 font-medium mb-6 italic" data-id="element-160" data-mp="bc2tt56qz3f2">
              Reconnect with yourself.
            </p>
            <p className="text-cream-50/80 mb-8 flex-grow" data-id="element-161" data-mp="q9v5fm96b7nz">
              Return to your inner compass and trust your intuition. In these
              personal sessions, online or in nature, we focus on your unique
              path to clarity and confidence.
            </p>
            <Button variant="outline" href="#contact" className="w-full" data-id="element-162" data-mp="3oqz8ckin5kul">
              Start Your Journey
            </Button>
          </Card>

          {/* Group Journeys */}
          <Card hover className="flex flex-col items-center text-center border-t-4 border-t-gold-400" data-id="element-163" data-mp="7ckaueyhl2ev">
            <div className="w-16 h-16 rounded-full bg-gold-400/10 flex items-center justify-center mb-6 text-gold-400" data-id="element-164" data-mp="3az10se4kvx0j">
              <Users size={32} strokeWidth={1.5} data-id="element-165" data-mp="35zems2gxecqo" />
            </div>
            <h3 className="font-serif text-2xl text-cream-50 mb-2" data-id="element-166" data-mp="1lip1a8d1klr2">
              Group Journeys
            </h3>
            <p className="text-gold-400 font-medium mb-6 italic" data-id="element-167" data-mp="1q9f69khk2ml8">
              Reconnect with nature.
            </p>
            <p className="text-cream-50/80 mb-8 flex-grow" data-id="element-168" data-mp="1blkcs1vq4e73">
              Be part of a warm, grounded community and rediscover clarity
              through shared experience outdoors during our transformative
              weekend retreats.
            </p>
            <Button variant="outline" href="#contact" className="w-full" data-id="element-169" data-mp="297rhrcvxw8jz">
              Join the Group
            </Button>
          </Card>
        </div>
      </div>
    </section>;
}